module.exports = __webpack_public_path__ + "d664201f/img/scraper-icon.df6ccde5.svg";